import React from 'react';
import DatetimeWidget from '@plone/volto/components/manage/Widgets/DatetimeWidget';
import { dataEmBrasilia, meiaNoiteEmBrasilia } from './brasilia';

/**
 * Início e fim do evento de dia inteiro, no horário de Brasília.
 *
 * O widget de data do Volto manda só a data ("2026-10-23"); o Plone a grava
 * como meia-noite UTC, e tudo que a mostra (a página do evento, o "Baixar
 * evento", a busca) a lê em Brasília, três horas antes: o evento perdia um
 * dia. Aqui a data vai como a meia-noite de Brasília e, ao reabrir, o campo
 * mostra a data de Brasília, não a do fuso de quem edita. Fora do dia
 * inteiro, é o widget do Volto sem mudança.
 */

const DATA_PURA = /^\d{4}-\d{2}-\d{2}$/;

/** O valor gravado, como o widget deve mostrar (a data de Brasília). */
export const paraOWidget = (valor) => dataEmBrasilia(valor) || valor;

/** A data escolhida, como deve ir para o Plone (a meia-noite de Brasília). */
export const paraGravar = (valor) =>
  DATA_PURA.test(valor || '') ? meiaNoiteEmBrasilia(valor) : valor;

const DataDoEventoWidget = (props) => {
  const { id, formData, value, onChange } = props;
  const diaInteiro = (id === 'start' || id === 'end') && !!formData?.whole_day;
  if (!diaInteiro) return <DatetimeWidget {...props} />;
  return (
    <DatetimeWidget
      {...props}
      value={value ? paraOWidget(value) : value}
      onChange={(campo, valor) => onChange(campo, paraGravar(valor))}
    />
  );
};

export default DataDoEventoWidget;
